module.exports = __webpack_public_path__ + "static/media/ic_card.14d455ea.png";